<template>
  <v-card v-if="current_period_detail" class="fill-height">
    <DashboardBar title="Lista de IES" :back="false"/>
    <v-toolbar>
      <v-text-field
        class="mt-2 pt-2"
        label="Filtrar IES"
        append-icon="search"
        v-model="search_text"
      ></v-text-field>
      <v-spacer></v-spacer>
      <span>Año de registro: </span>
      <v-select
        class="mt-2 pt-2 ml-4 width-year"
        dense
        single-line
        :items="periods"
        label="año"
        v-model="selected_year"
        @change="changeYear()"
        item-text="year"
        item-value="id"
      >
        <template v-slot:selection="{item}">
          {{`${item.year}-${item.stage == 'final' ? 'Final': 'Avances'}`}}
        </template>
        <template v-slot:item="{item}">
          {{`${item.year}-${item.stage == 'final' ? 'Final': 'Avances'}`}}
        </template>
      </v-select>
    </v-toolbar>

    <v-subheader class="subtitle-1">IES:</v-subheader>
    <v-progress-circular 
      v-if="loading"
      :size="50"
      color="accent"
      indeterminate
    ></v-progress-circular>
    <v-card-actions class="pt-0" v-else>
      <v-list class="pt-0" three-line min-width="100%" outline>
        <v-divider></v-divider>
        <template v-for="ies in filter_ies || current_ies">
          <v-list-item>
            <!--
            <v-list-item-avatar>
              <v-img 
                :src="ies.logo"
                position="center"
                contain
              ></v-img>
            </v-list-item-avatar>-->
            <v-list-item-content class="text-left">
              <v-list-item-title>
                <span class="display-1 font-weight-bold">{{ies.siglas}} </span>
                <span class="body-1">
                  <b>{{ies.nombre}}</b>
                </span>
              </v-list-item-title>
              <v-list-item-subtitle class="title">
                {{ies.period_ies.status_registro.description}}
              </v-list-item-subtitle>
            </v-list-item-content>
            <div class="d-flex flex-md-row flex-column width-actions" min-width="240px">
              <span v-if="ies.period_ies.status_registro.name == 'with_data'">
                <v-btn 
                  outlined
                  class="mb-1 mx-1"
                  color="accent"
                  :to="`/dashboard/period_ies/${ies.period_ies.id}`"
                >
                  Ver Resultados
                </v-btn>
                <v-tooltip bottom class="ml-2">
                  <template v-slot:activator="{ on }">
                    <v-btn icon color="accent" v-on="on" 
                      :href="`${api_url}/period/avg/export/${ies.id}`">
                      <v-icon >cloud_download</v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar resultados</span>
                </v-tooltip>
              </span>
              <v-btn
                v-else-if="ies.period_ies.status_registro.name == 'in_review'"
                outlined
                class="mb-1 mx-1"
                color="accent"
                :to="`/dashboard/period_ies/${ies.period_ies.id}`"
              >
                Verificar
              </v-btn>
              <span 
                v-else-if="ies.period_ies.status_registro.name == 'middle_data'"
                class="grey--text"
              >
                <v-btn 
                  outlined
                  class="mb-1 mx-1"
                  color="accent"
                  :to="`/dashboard/period_ies/${ies.period_ies.id}`"
                >
                  Ver Información
                </v-btn>
              </span>
              <span v-else class="grey--text"> --- --- </span>
            </div>
          </v-list-item>
          <v-divider></v-divider>
        </template>
      </v-list>
    </v-card-actions>
  </v-card>
</template>


<script>

import router from "@/router.js";
import { mapState } from "vuex";
import DashboardBar from "@/components/dashboard/DashboardBar.vue";
import { API_URL } from "@/common/config";

export default {
  name: 'ReviewerHome',
  components: {
    DashboardBar,
  },
  data(){
    return {
      hover: false,
      search_text: "",
      loading: false,
      api_url: undefined,
      selected_year: undefined,
      filter_ies: undefined,
      timeout_value: null,
      action_buttons:[
        {name:'init_register', text:'Comenzar registro'},
        //{name:'send_to_review', text:'Enviar a Revisión'},
        {name:'register_advances', text:'Registrar avances'},
      ],
    }
  },
  computed:{
    ...mapState({
      current_period_detail: state => state.current_period_detail,
      periods: state => state.periods,
      last_period: state => state.last_period,
    }),
    current_ies(){
      if (!this.current_period_detail.ies) return undefined
      var order_ies = this.current_period_detail.ies.filter(cp=>
        cp.period_ies.status_registro.name == 'in_review')
      return [...order_ies, ...this.current_period_detail.ies.filter(cp=>
        cp.period_ies.status_registro.name != 'in_review')]
    },
  },  
  methods:{
    debounceSearch(debounceDuration = 500) {
      if(this.timeout_value !== null) {
        clearTimeout(this.timeout_value);
      }
      this.timeout_value = setTimeout( _ => {
        this.filterIes();
      }, debounceDuration);
    },
    changeYear(){
      //router.replace()
      this.loading=true;
      var selected_period= this.periods.find(pr=>pr.id ==this.selected_year)
      this.$store.dispatch('GET_PERIOD', selected_period).then(()=>{
          this.loading=false;
          this.filter_ies = undefined;
        })

    },
    filterIes(){
      var new_ies = this.current_period_detail.ies.filter(ies=>
        ies.nombre.toLowerCase().includes(this.search_text.toLowerCase())
        || ies.siglas.toLowerCase().includes(this.search_text.toLowerCase()))
      this.filter_ies = new_ies
    }
  },
  created(){
    this.api_url= process.env.VUE_APP_URL
    if (!this.current_period_detail){
      this.loading=true;
      this.$store.dispatch("FETCH_PERIODS").then((data)=>{
        this.selected_year = this.last_period.id
        this.$store.dispatch('GET_PERIOD').then(()=>{
          this.loading=false;
        })
      })
    }
    else{
      this.$store.dispatch('GET_PERIOD', this.current_period_detail).then(()=>{
        this.loading=false;
      })
      this.selected_year = this.current_period_detail.id
    }      

  },
  watch: {
    search_text: function(newValue, previousValue) {
      if (newValue.length > 1){
        this.debounceSearch()
      }
      else
        this.filter_ies = this.current_period_detail.ies
    }
  },
} 

</script>


<style lang="scss" scoped>
.header-with{
  max-width: 700px;
}
.width-actions{
  min-width: 240px;
}
.width-year{
  max-width: 150px;
}
</style>